import {useHasGlassesCare} from 'desktop/hooks/useHasGlassesCare/useHasGlassesCare';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {useGetPrimerToken} from 'desktop/pages/checkout/hooks/primer/useGetPrimerToken';
import {validateOrder} from 'libs/checkout/requests/validatePrimerOrder';

/**
 * Validate Order
 * */
export function useValidateOrder() {
    const {token: primerToken} = useGetPrimerToken();
    const hasGlassesCare = useHasGlassesCare();

    return {
        validateOrder: async (paymentMethod: PAYMENTS) =>
            await validateOrder(paymentMethod, primerToken || '', hasGlassesCare),
    };
}
